import { VOTEBOX_SUCCESS_COLOR } from "../voteboxTokens";

// Fill of a selected option: its own color for a deliberation, green for a candidate.
export function getSelectionColor(optionColor?: string): string {
    return optionColor || VOTEBOX_SUCCESS_COLOR;
}
